export const USER_COUNTRY_CODE_STORAGE_KEY = 'user-country-code';
export const USER_COUNTRY_NAME_STORAGE_KEY = 'user-country-name';
export const LOCATION_INITIALIZED_EVENT = 'location-initialized';

export const EU_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'SI',
  'ES',
] as const;

export const COMMON_CURRENCY_CODES = [
  'USD',
  'EUR',
  'GBP',
  'CHF',
  'CAD',
  'AUD',
  'NZD',
  'JPY',
  'CNY',
  'HKD',
  'SGD',
  'INR',
  'KRW',
  'BRL',
  'MXN',
  'ZAR',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'CZK',
  'HUF',
  'TRY',
  'AED',
  'SAR',
  'ILS',
] as const;

const COUNTRY_CODES = [
  'AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AR', 'AS', 'AT', 'AU',
  'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ',
  'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ',
  'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO',
  'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO',
  'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM',
  'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM',
  'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN',
  'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS',
  'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP',
  'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT',
  'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML',
  'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX',
  'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR',
  'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN',
  'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA',
  'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN',
  'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG',
  'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ',
  'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN',
  'VU', 'WF', 'WS', 'XK', 'YE', 'YT', 'ZA', 'ZM', 'ZW',
] as const;

const COUNTRY_NAME_OVERRIDES: Record<string, string> = {
  AX: 'Aland Islands',
  BQ: 'Caribbean Netherlands',
  BV: 'Bouvet Island',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Congo - Kinshasa',
  CF: 'Central African Republic',
  CG: 'Congo - Brazzaville',
  CI: "Cote d'Ivoire",
  CV: 'Cape Verde',
  CW: 'Curacao',
  CZ: 'Czechia',
  EH: 'Western Sahara',
  FK: 'Falkland Islands',
  FM: 'Micronesia',
  FO: 'Faroe Islands',
  GB: 'United Kingdom',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GL: 'Greenland',
  GP: 'Guadeloupe',
  GS: 'South Georgia & South Sandwich Islands',
  HM: 'Heard & McDonald Islands',
  IO: 'British Indian Ocean Territory',
  IR: 'Iran',
  JE: 'Jersey',
  KP: 'North Korea',
  KR: 'South Korea',
  KY: 'Cayman Islands',
  LA: 'Laos',
  MF: 'Saint Martin',
  MH: 'Marshall Islands',
  MK: 'North Macedonia',
  MM: 'Myanmar (Burma)',
  MO: 'Macao',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MS: 'Montserrat',
  NC: 'New Caledonia',
  NF: 'Norfolk Island',
  PM: 'Saint Pierre & Miquelon',
  PN: 'Pitcairn Islands',
  PS: 'Palestine',
  RE: 'Reunion',
  RU: 'Russia',
  SJ: 'Svalbard & Jan Mayen',
  ST: 'Sao Tome & Principe',
  SX: 'Sint Maarten',
  SY: 'Syria',
  TC: 'Turks & Caicos Islands',
  TF: 'French Southern Territories',
  TL: 'Timor-Leste',
  UM: 'U.S. Outlying Islands',
  US: 'United States',
  VA: 'Vatican City',
  VC: 'St. Vincent & Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VI: 'U.S. Virgin Islands',
  WF: 'Wallis & Futuna',
  XK: 'Kosovo',
};

const COUNTRY_CURRENCY_MAP: Record<string, string> = {
  AD: 'EUR',
  AE: 'AED',
  AF: 'AFN',
  AG: 'XCD',
  AI: 'XCD',
  AL: 'ALL',
  AM: 'AMD',
  AO: 'AOA',
  AR: 'ARS',
  AS: 'USD',
  AU: 'AUD',
  AW: 'AWG',
  AX: 'EUR',
  AZ: 'AZN',
  BA: 'BAM',
  BB: 'BBD',
  BD: 'BDT',
  BF: 'XOF',
  BH: 'BHD',
  BI: 'BIF',
  BJ: 'XOF',
  BL: 'EUR',
  BM: 'BMD',
  BN: 'BND',
  BO: 'BOB',
  BQ: 'USD',
  BR: 'BRL',
  BS: 'BSD',
  BT: 'BTN',
  BV: 'NOK',
  BW: 'BWP',
  BY: 'BYN',
  BZ: 'BZD',
  CA: 'CAD',
  CC: 'AUD',
  CD: 'CDF',
  CF: 'XAF',
  CG: 'XAF',
  CH: 'CHF',
  CI: 'XOF',
  CK: 'NZD',
  CL: 'CLP',
  CM: 'XAF',
  CN: 'CNY',
  CO: 'COP',
  CR: 'CRC',
  CU: 'CUP',
  CV: 'CVE',
  CW: 'ANG',
  CX: 'AUD',
  DJ: 'DJF',
  DK: 'DKK',
  DM: 'XCD',
  DO: 'DOP',
  DZ: 'DZD',
  EC: 'USD',
  EG: 'EGP',
  EH: 'MAD',
  ER: 'ERN',
  ET: 'ETB',
  FJ: 'FJD',
  FK: 'FKP',
  FM: 'USD',
  FO: 'DKK',
  GA: 'XAF',
  GD: 'XCD',
  GE: 'GEL',
  GF: 'EUR',
  GG: 'GBP',
  GH: 'GHS',
  GI: 'GIP',
  GL: 'DKK',
  GM: 'GMD',
  GN: 'GNF',
  GP: 'EUR',
  GQ: 'XAF',
  GS: 'GBP',
  GT: 'GTQ',
  GU: 'USD',
  GW: 'XOF',
  GY: 'GYD',
  HK: 'HKD',
  HM: 'AUD',
  HN: 'HNL',
  HT: 'HTG',
  ID: 'IDR',
  IL: 'ILS',
  IM: 'GBP',
  IN: 'INR',
  IO: 'USD',
  IQ: 'IQD',
  IR: 'IRR',
  IS: 'ISK',
  JE: 'GBP',
  JM: 'JMD',
  JO: 'JOD',
  JP: 'JPY',
  KE: 'KES',
  KG: 'KGS',
  KH: 'KHR',
  KI: 'AUD',
  KM: 'KMF',
  KN: 'XCD',
  KP: 'KPW',
  KR: 'KRW',
  KW: 'KWD',
  KY: 'KYD',
  KZ: 'KZT',
  LA: 'LAK',
  LB: 'LBP',
  LC: 'XCD',
  LI: 'CHF',
  LK: 'LKR',
  LR: 'LRD',
  LS: 'LSL',
  LY: 'LYD',
  MA: 'MAD',
  MC: 'EUR',
  MD: 'MDL',
  ME: 'EUR',
  MF: 'EUR',
  MG: 'MGA',
  MH: 'USD',
  MK: 'MKD',
  ML: 'XOF',
  MM: 'MMK',
  MN: 'MNT',
  MO: 'MOP',
  MP: 'USD',
  MQ: 'EUR',
  MR: 'MRU',
  MS: 'XCD',
  MU: 'MUR',
  MV: 'MVR',
  MW: 'MWK',
  MX: 'MXN',
  MY: 'MYR',
  MZ: 'MZN',
  NA: 'NAD',
  NC: 'XPF',
  NE: 'XOF',
  NF: 'AUD',
  NG: 'NGN',
  NI: 'NIO',
  NO: 'NOK',
  NP: 'NPR',
  NR: 'AUD',
  NU: 'NZD',
  NZ: 'NZD',
  OM: 'OMR',
  PA: 'PAB',
  PE: 'PEN',
  PF: 'XPF',
  PG: 'PGK',
  PH: 'PHP',
  PK: 'PKR',
  PL: 'PLN',
  PM: 'EUR',
  PN: 'NZD',
  PR: 'USD',
  PS: 'ILS',
  PW: 'USD',
  PY: 'PYG',
  QA: 'QAR',
  RE: 'EUR',
  RS: 'RSD',
  RU: 'RUB',
  RW: 'RWF',
  SA: 'SAR',
  SB: 'SBD',
  SC: 'SCR',
  SD: 'SDG',
  SE: 'SEK',
  SG: 'SGD',
  SH: 'SHP',
  SL: 'SLE',
  SM: 'EUR',
  SN: 'XOF',
  SO: 'SOS',
  SR: 'SRD',
  SS: 'SSP',
  ST: 'STN',
  SV: 'USD',
  SX: 'ANG',
  SY: 'SYP',
  SZ: 'SZL',
  TC: 'USD',
  TD: 'XAF',
  TF: 'EUR',
  TG: 'XOF',
  TH: 'THB',
  TJ: 'TJS',
  TK: 'NZD',
  TL: 'USD',
  TM: 'TMT',
  TN: 'TND',
  TO: 'TOP',
  TR: 'TRY',
  TT: 'TTD',
  TV: 'AUD',
  TW: 'TWD',
  TZ: 'TZS',
  UA: 'UAH',
  UG: 'UGX',
  UM: 'USD',
  US: 'USD',
  UY: 'UYU',
  UZ: 'UZS',
  VA: 'EUR',
  VC: 'XCD',
  VE: 'VES',
  VG: 'USD',
  VI: 'USD',
  VN: 'VND',
  VU: 'VUV',
  WF: 'XPF',
  WS: 'WST',
  XK: 'EUR',
  YE: 'YER',
  YT: 'EUR',
  ZA: 'ZAR',
  ZM: 'ZMW',
  ZW: 'USD',
};

const COUNTRY_CURRENCY_FALLBACKS: Record<string, string> = {
  AR: 'USD',
  CL: 'USD',
  CO: 'USD',
  ID: 'USD',
  MY: 'SGD',
  NG: 'USD',
  PH: 'USD',
  PK: 'USD',
  TH: 'USD',
  TW: 'USD',
  UA: 'EUR',
  VN: 'USD',
};

export type CountryOption = {
  code: string;
  name: string;
  currency: string;
};

const countryNameFormatter = typeof Intl !== 'undefined' && 'DisplayNames' in Intl
  ? new Intl.DisplayNames(['en'], { type: 'region' })
  : null;

export const getCountryName = (countryCode: string) => {
  const normalizedCode = countryCode.toUpperCase();

  return COUNTRY_NAME_OVERRIDES[normalizedCode]
    || countryNameFormatter?.of(normalizedCode)
    || normalizedCode;
};

export const countries: CountryOption[] = COUNTRY_CODES.map((countryCode) => ({
  code: countryCode,
  name: getCountryName(countryCode),
  currency: COUNTRY_CURRENCY_MAP[countryCode] || (EU_COUNTRY_CODES.includes(countryCode as typeof EU_COUNTRY_CODES[number]) ? 'EUR' : 'USD'),
}));

export const getStoredUserCountryCode = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return localStorage.getItem(USER_COUNTRY_CODE_STORAGE_KEY);
};

export const getStoredUserCountryName = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return localStorage.getItem(USER_COUNTRY_NAME_STORAGE_KEY);
};

export const persistUserCountry = (countryCode: string, countryName?: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedCode = countryCode.toUpperCase();
  const resolvedName = countryName || getCountryName(normalizedCode);

  localStorage.setItem(USER_COUNTRY_CODE_STORAGE_KEY, normalizedCode);
  localStorage.setItem(USER_COUNTRY_NAME_STORAGE_KEY, resolvedName);
  window.dispatchEvent(
    new CustomEvent(LOCATION_INITIALIZED_EVENT, {
      detail: {
        code: normalizedCode,
        name: resolvedName,
      },
    })
  );
};

export const getPreferredCurrencyForCountry = (
  countryCode: string,
  availableCurrencies: readonly string[] = COMMON_CURRENCY_CODES
) => {
  const normalizedCode = countryCode.toUpperCase();
  const normalizedAvailableCurrencies = availableCurrencies.map((currency) => currency.toUpperCase());
  const preferredCurrency = COUNTRY_CURRENCY_MAP[normalizedCode]
    || (EU_COUNTRY_CODES.includes(normalizedCode as typeof EU_COUNTRY_CODES[number]) ? 'EUR' : 'USD');

  if (normalizedAvailableCurrencies.length === 0) {
    return preferredCurrency;
  }

  if (normalizedAvailableCurrencies.includes(preferredCurrency)) {
    return preferredCurrency;
  }

  const fallbackCurrency = COUNTRY_CURRENCY_FALLBACKS[normalizedCode];

  if (fallbackCurrency && normalizedAvailableCurrencies.includes(fallbackCurrency)) {
    return fallbackCurrency;
  }

  if (['GG', 'IM', 'JE', 'GS'].includes(normalizedCode) && normalizedAvailableCurrencies.includes('GBP')) {
    return 'GBP';
  }

  if (['LI'].includes(normalizedCode) && normalizedAvailableCurrencies.includes('CHF')) {
    return 'CHF';
  }

  if (EU_COUNTRY_CODES.includes(normalizedCode as typeof EU_COUNTRY_CODES[number]) && normalizedAvailableCurrencies.includes('EUR')) {
    return 'EUR';
  }

  return normalizedAvailableCurrencies.includes('USD') ? 'USD' : normalizedAvailableCurrencies[0];
};
